import AddIcon from '@mui/icons-material/Add';
import { Button, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { V2ThemeProvider } from '@onevision-resources/design-theme';
import { isSingletonBlockType } from '@provision/landing-page-utils';
import { useState } from 'react';
import { addBlockButtonSx } from 'src/pages/Settings/memberships/components/landing-page-tab/styled';
import {
  BLOCK_TYPE_LABELS,
  BLOCK_TYPE_ORDER,
  type LandingPageBlockType,
} from 'src/pages/Settings/memberships/components/landing-page-tab/types';

interface AddBlockMenuProps {
  presentTypes: ReadonlySet<LandingPageBlockType>;
  onAdd: (type: LandingPageBlockType) => void;
}

export const AddBlockMenu = ({ presentTypes, onAdd }: AddBlockMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleAdd = (type: LandingPageBlockType) => {
    setAnchorEl(null);
    onAdd(type);
  };

  return (
    <>
      <Button
        startIcon={<AddIcon />}
        variant="outlined"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={addBlockButtonSx}
      >
        Add block
      </Button>
      <V2ThemeProvider>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
          {BLOCK_TYPE_ORDER.map((type) => {
            const alreadyUsed = isSingletonBlockType(type) && presentTypes.has(type);

            return (
              <MenuItem key={type} disabled={alreadyUsed} onClick={() => handleAdd(type)}>
                <ListItemText>{BLOCK_TYPE_LABELS[type]}</ListItemText>
                {alreadyUsed ? (
                  <Typography variant="caption" color="text.secondary" sx={{ pl: 2 }}>
                    Added
                  </Typography>
                ) : null}
              </MenuItem>
            );
          })}
        </Menu>
      </V2ThemeProvider>
    </>
  );
};
